import { createContext, Dispatch, FC, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';
import { Application } from '../../../../types/Application';

interface DeleteApplicationContextProperties {
    applicationToDelete?: Application | null | undefined;
    deleteApplicationLoading: boolean;
    setApplicationToDelete: Dispatch<SetStateAction<Application | null | undefined>>;
    setDeleteApplicationLoading: Dispatch<SetStateAction<boolean>>;
}

const defaultProperties: DeleteApplicationContextProperties = {
    applicationToDelete: undefined,
    deleteApplicationLoading: false,
    setApplicationToDelete: () => {},
    setDeleteApplicationLoading: () => {}
};

export const DeleteApplicationContext = createContext<DeleteApplicationContextProperties>(defaultProperties);

export const DeleteApplicationProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [applicationToDelete, setApplicationToDelete] = useState<Application | null | undefined>(null);
    const [deleteApplicationLoading, setDeleteApplicationLoading] = useState(false);

    const contextValue = useMemo(
        () => ({
            applicationToDelete,
            deleteApplicationLoading,
            setApplicationToDelete,
            setDeleteApplicationLoading
        }),
        [applicationToDelete, deleteApplicationLoading]
    );

    return <DeleteApplicationContext.Provider value={contextValue}>{children}</DeleteApplicationContext.Provider>;
};

export const useDeleteApplicationContext = (): DeleteApplicationContextProperties =>
    useContext(DeleteApplicationContext);
